import script from "./DetailBaseCustomTableWidget.vue?vue&type=script&lang=ts"
export * from "./DetailBaseCustomTableWidget.vue?vue&type=script&lang=ts"

import "./DetailBaseCustomTableWidget.vue?vue&type=style&index=0&id=7268685c&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7268685c"]])

export default __exports__